import React, { useState, useEffect } from 'react';
import { Typography, Box, Container, Stack } from '@mui/material'
import PhoneEnabledIcon from '@mui/icons-material/PhoneEnabled';
import Logo from '../logo/Logo'
import Contact from '../contact/Contact'
import ContactSm from '../contact/ContactSm'
import { StyledSubmitButton } from '../../../components/styled-components/button';


function Header() {
    const [HeaderLabel, setHeaderLabel] = useState('619-353-5653');
    return (
        <>
            <Typography component={'header'} position={'sticky'} top={0} zIndex={1500} boxShadow={1}>
                <Box py={{ xs: 0, md: 2 }} sx={{ backgroundColor: 'common.white', maxHeight: { xs: '78px', md: '83px' } }}>
                    <Container fixed>
                        <Box position={'relative'} display={{
                            xs: 'flex', md: 'flex', justifyContent: "space-between",
                            alignItems: "center"
                        }} gap={1}>
                            {/* <Box position={{ xs: 'static', md: 'absolute' }} top={{ xs: '0', md: '-50px' }}> */}
                            <Box sx={{ transform: { xs: 'translateY(0)', md: 'translateY(-5px)' } }}>
                                <a href='https://bigbox.com' onClick={() => { sessionStorage.clear() }}><Logo /></a>
                            </Box>
                            <StyledSubmitButton variant='contained' href="tel:6193535653" startIcon={<PhoneEnabledIcon />} sx={{ maxHeight: { xs: '45px', md: '53px' }, transform: { sm: 'translateY(0)', md: 'translateY(-30px)' } }}>
                                {HeaderLabel}
                                {/* <Contact label={HeaderLabel} /> */}
                                {/* <ContactSm label={HeaderLabel} /> */}
                            </StyledSubmitButton>
                        </Box>
                    </Container>
                </Box>
                <Box display={{
                    xs: 'flex', md: 'flex', justifyContent: { xs: 'center', md: 'space-between' },
                    alignItems: "center"
                }} sx={{ backgroundColor: 'primary.main', minHeight: { xs: '70px', md: '50px', lg: '60px' }, boxShadow: '0px 7px 13.6px rgba(0, 0, 0, 0.25)' }} >
                    <Container>
                        <Typography sx={{ color: 'common.white', fontSize: { xs: '22px', md: '22px', lg: '22px' }, textAlign: { xs: 'left', md: 'left' }, maxWidth: { xs: '100%', md: '80%' }, ml: { md: 'auto' }, mr: { md: '0' }, fontFamily: `'program', sans-serif`, fontWeight: '600', letterSpacing: '1.01px' }} >
                            Limited time offer! $50 off plus  Free delivery on 4+ month rentals.
                        </Typography>
                    </Container>
                </Box>
            </Typography >
        </>
    )
}

export default Header
